import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const pageContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  px: '48px',
  py: '24px',
};

export const headerActions: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  whiteSpace: 'nowrap',
};

export const tabs: SxProps<Theme> = {
  alignSelf: 'stretch',
  borderBottom: `1px solid ${atlasSemantic.color.ui.divider.default}`,
};

export const toolbar: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '12px',
  flexWrap: 'wrap',
};

export const searchField: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '320px',
};

export const searchLabel: SxProps<Theme> = {
  fontSize: '13px',
  color: atlasSemantic.color.type.muted,
};

export const tableContainer: SxProps<Theme> = {
  border: `1px solid ${atlasSemantic.color.ui.divider.default}`,
  borderRadius: `${atlasSemantic.radius.md}`,
  overflowX: 'auto',
};

export const table: SxProps<Theme> = {
  minWidth: 1044,
};

export const fieldsTable: SxProps<Theme> = {
  minWidth: 1160,
  width: '100%',
  tableLayout: 'fixed',
};

export const headerRow: SxProps<Theme> = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
};

export const headerCell: SxProps<Theme> = {
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const cell: SxProps<Theme> = { whiteSpace: 'nowrap' };

export const statusCell: SxProps<Theme> = {
  ...cell,
  width: '120px',
  minWidth: '120px',
};

export const labelCell: SxProps<Theme> = {
  ...cell,
  width: '200px',
  minWidth: '200px',
};

export const identifierCell: SxProps<Theme> = {
  ...cell,
  width: '180px',
  minWidth: '180px',
};

export const sectionCell: SxProps<Theme> = {
  ...cell,
  width: '120px',
  minWidth: '120px',
};

export const typeCell: SxProps<Theme> = {
  ...cell,
  width: '140px',
  minWidth: '140px',
};

export const dateCell: SxProps<Theme> = {
  ...cell,
  width: '140px',
  minWidth: '140px',
};

export const createdByCell: SxProps<Theme> = {
  ...cell,
  width: '180px',
  minWidth: '180px',
};

export const actionsCell: SxProps<Theme> = {
  ...cell,
  width: '80px',
  minWidth: '80px',
};

export const typeChip: SxProps<Theme> = {
  borderColor: atlasSemantic.color.action.secondary.outline,
  color: atlasSemantic.color.type.default,
  height: '24px',
};

export const emptyWrapper: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  py: '48px',
};

export const paginationContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  borderTop: `1px solid ${atlasSemantic.color.ui.divider.default}`,
  px: '16px',
};

export const orderCell: SxProps<Theme> = {
  ...cell,
  width: '80px',
  minWidth: '80px',
};

export const orderCellContent: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const dragHandle: SxProps<Theme> = {
  display: 'flex',
  cursor: 'grab',
  color: atlasSemantic.color.type.muted,
};

export const draggingRow: SxProps<Theme> = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
  boxShadow: 2,
  display: 'table',
  tableLayout: 'fixed',
  width: '100%',
};
